<template>
  <el-dialog
    :title="$t('file.ImportCustomers')"
    :visible.sync="dialogVisible"
    width="800px"
    class="importTraderDialog"
    @close="dialogCloseHandle"
  >
    <div class="common_readonly_template">
      <el-row>
        <el-col :span="24">
          <div>
            <div class="label">{{ $t('file.CustomerInfoIT') }}</div>
            <div class="text">
              <span @click="templateDownload">
                <i class="iconfont icon-xiazai-Icon" />
                {{ $t('file.Ctdtt') }}
              </span>
            </div>
          </div>
        </el-col>
        <el-col :span="24">
          <div>
            <div class="label">{{ $t('file.FileU') }}</div>
            <div class="text">
              <div>
                <el-upload
                  ref="importTraderUpload"
                  class="upload-demo"
                  :action="baseUrl"
                  :headers="uploadheaders"
                  :with-credentials="true"
                  :on-remove="beforeRemove"
                  :before-upload="beforeUpload"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :data="uploadData"
                  multiple
                  :limit="1"
                  :file-list="fileList"
                  :auto-upload="false"
                >
                  <el-button type="primary" :disabled="fileList.length > 1">
                    <i class="iconfont icon-shangchuan-icon1" />
                    {{ $t('file.ctu') }}
                  </el-button>
                  <span slot="tip" class="el-upload__tip">{{ $t('file.SupFF') }}</span>
                </el-upload>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--    <div class="downloadTemplate">客户信息导入模板：<span @click="templateDownload">点击下载模板</span></div>-->
    <!--    <div class="title">文件上传</div>-->
    <!--    <el-upload-->
    <!--      ref="importTraderUpload"-->
    <!--      class="upload-demo"-->
    <!--      :action="baseUrl"-->
    <!--      :headers="uploadheaders"-->
    <!--      :with-credentials="true"-->
    <!--      :on-remove="beforeRemove"-->
    <!--      :before-upload="beforeUpload"-->
    <!--      :on-success="handleSuccess"-->
    <!--      :data="uploadData"-->
    <!--      multiple-->
    <!--      :limit="1"-->
    <!--      :file-list="fileList"-->
    <!--      :auto-upload="false"-->
    <!--    >-->
    <!--      <el-button size="small" type="primary" :disabled="fileList.length > 1">点击上传</el-button>-->
    <!--      <div slot="tip" class="el-upload__tip">支持文件格式：.xls .xlsx</div>-->
    <!--    </el-upload>-->
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogCloseHandle">{{ $t('btn.Cancel') }}</el-button>
      <el-button type="primary" @click="submitUpload">{{ $t('btn.OK') }}</el-button>
    </div>
    <customerDialog
      ref="customerDialog"
      :export-customer-visible="exportCustomerVisible"
      :calibration="calibration"
      @dialogCloseHandle="exportCustomerDialogCloseHandle"
      @dialogSuccessHandle="dialogSuccessHandle"
    />
  </el-dialog>
</template>

<script>
import { travellingTrader } from '../../../service';
import requestBaseUrl from '@/API/request/baseUrl';
import { getTicket } from '@/utils/utils';
import customerDialog from '@/components/customerDialog';
import { confirmBusiness } from '@/utils/exportComplianceDialog';
export default {
  components: {
    customerDialog
  },
  data () {
    return {
      dialogVisible: false,
      uploadheaders: {
        sysId: window._env_.VUE_APP_SYSID,
        union_session_ticket: getTicket()
      },
      baseUrl: `${requestBaseUrl}/customer/calibration/excel/2/`,
      fileList: [],
      uploadData: {},
      exportCustomerVisible: false,
      calibration: {}
    };
  },
  props: {
    importTraderVisible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    importTraderVisible (val) {
      if (val) {
      }
      this.dialogVisible = val;
    }
  },
  methods: {
    submitUpload () {
      this.$refs.importTraderUpload.submit();
    },
    templateDownload () {
      travellingTrader.getDownloadTemplate().then(res => {
        if (res.status === '200') {
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = res.data;
          link.setAttribute('download', '');
          document.body.appendChild(link);
          link.click();
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    },
    beforeUpload (file) {
      let fileSize = file.size / 1024 / 1024 < 10;
      if (!fileSize) {
        this.$message.error(this.$t('file.uFn10M'));
      }
      this.$store.commit('setSubPageLoading', true);
      return fileSize;
    },
    handleSuccess (response, file, fileList) {
      this.$store.commit('setSubPageLoading', false);
      confirmBusiness(this, response, { notifyError: true }).then(passed => {
        if (passed) {
          if (response.data.hasCalibration) {
            this.fileList = [];
            this.$emit('dialogCloseHandle');
            this.calibration = response.data.calibration;
            this.exportCustomerVisible = true;
          } else {
            this.$emit('dialogCloseHandle');
            this.$message.success(this.$t('general.ImpSucc'));
            this.fileList = [];
          }
        }
      });
    },
    handleError () {
      this.$store.commit('setSubPageLoading', false);
      this.$message.error(this.$t('file.Fuf'));
    },
    beforeRemove (file, fileList) {
      this.$message({
        type: 'success',
        message: this.$t('general.DeleSucc')
      });
    },
    exportCustomerDialogCloseHandle () {
      this.exportCustomerVisible = false;
      this.$emit('dialogCloseHandle');
    },
    dialogSuccessHandle () {
      this.exportCustomerVisible = false;
      this.$emit('dialogSuccessHandle');
    }
  },
  mounted () {
    if (this.$route.query.activityCode) {
      this.baseUrl = this.baseUrl + this.$route.query.activityCode;
    }
  }
};
</script>

<style lang="scss" scoped>
.importTraderDialog {
  .common_readonly_template {
    .text > span {
      color: #508db4;
      margin-left: 8px;
      cursor: pointer;
      > i {
        margin-right: 8px;
        font-size: 14px;
      }
    }
    .el-upload__tip {
      color: #5b646e;
      margin-left: 10px;
    }
  }
  .title {
    font-weight: bold;
    margin: 20px 0 16px;
  }
}
</style>
